import { ThemeTypeObj } from "@/config/theme"
import { ThemeType } from "@/types/global";
import { useLocalStorageState } from "ahooks";
import { useEffect, useState } from "react"
import { setEnterpriseTheme, getEnterpriseDefaultTheme } from "@/utils/enterpriseTheme";

export const useCustomTheme = () => {
    // const [currentTheme, setTheme] = useState(ThemeTypeObj.light)
    const [currentTheme, setTheme] = useLocalStorageState<string | undefined>(
        'custom-theme',
        {
            defaultValue: getEnterpriseDefaultTheme(), // 使用企业的默认主题
        },
    );
    const toggleTheme = (theme: ThemeType) => {
        setTheme(theme);
    };

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', currentTheme);
        // 主题切换时重新应用企业主题
        setEnterpriseTheme();
    }, [currentTheme]);

    return { currentTheme, toggleTheme };
}